import React from 'react';
import { Link } from 'react-router-dom';
import Button from '~/src/components/Button';
import analyticsService from '~/src/services/analytics';

type ActionButtonsProps = {
  allProcessed: boolean;
  onSelectMoreDocuments?: () => void;
  className?: string;
};

const ActionButtons = ({
  allProcessed,
  onSelectMoreDocuments,
  className = '',
}: ActionButtonsProps) => {
  const handleSelectMoreDocumentsClick = () => {
    analyticsService.track(
      'Drafting Specialist - Clicked on Select More Documents',
      {},
    );
    onSelectMoreDocuments?.();
  };

  return (
    <div className={`flex gap-3 justify-end ${className}`}>
      {allProcessed ? (
        <Link to="/templates/setup" onClick={handleSelectMoreDocumentsClick}>
          <Button className="h-8 text-xs font-medium">
            Select more documents
          </Button>
        </Link>
      ) : (
        <Button className="h-8 text-xs font-medium" disabled>
          Select more documents
        </Button>
      )}
    </div>
  );
};

export default ActionButtons;
